"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyExactDamage = void 0;
const Damage_1 = require("../Damage");
const Duration_1 = require("../Duration");
const core_1 = require("../effects/core");
function applyExactDamage(args) {
    var _a;
    const { attackerId, targetId, damage } = args;
    let { sequence } = args;
    const damageId = this.applyEffect(sequence, attackerId, targetId, core_1.DamageEffectArgs.fromExactAmount(this, damage.type, attackerId, targetId, damage.amount), Duration_1.Duration.Instant);
    return {
        damage: (_a = this.getEffect(damageId).args.damage) !== null && _a !== void 0 ? _a : Damage_1.Damage.None
    };
}
exports.applyExactDamage = applyExactDamage;
